import {EventEmitter, Injectable}   from "@angular/core";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { AuthService } from "../../base-module/base-service/auth.service";
import { Observable } from "rxjs";
import {HttpClient} from "@angular/common/http";

@Injectable()
export class TipoReceitaService {

    public empresaPadrao = new EventEmitter<any>();

    constructor(private authService: AuthService,
                private _http: HttpClient,
                public utilitesService: UtilitesService) {
    }

    /**
     * Tipo de Receitas por id
     * @param id ID da Tipo de Receitas
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "tipo-receitas/" + id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista de Tipo de Receitas
     * @param id ID da Tipo de Receitas
     */
    getAll(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "tipo-receitas"+env, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista de Tipo de Receitas
     * @param id ID da Tipo de Receitas
     */
    search(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "tipo-receitas"+env, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Delete de Tipo de Receitas
     * @param id ID da Tipo de Receitas
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "tipo-receitas/"+id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Cadastra Tipo de Receitas
     * @param params Json Tipo de Receitas
     */
    create(params: any):Observable<any>{
        return this._http.post(this.utilitesService.urlPrefix + "tipo-receitas", JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Atualiza Tipo de Receitas
     * @param params Json Tipo de Receitas
     */
    update(id: number, params: any):Observable<any>{
        return this._http.put(this.utilitesService.urlPrefix + "tipo-receitas/"+id, JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }

}
